import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Modal } from '../../canvasComponents/index';
// messages
import messages from './messages';
// Error types
import { ENTERPRISE_SEARCH_LOCATIONS, AUDATARGET_SEARCH_VENDOR } from '../../containers/Error/ErrorTypes';

function ErrorPopUpServices({ open, closeErrorPopUp, service }) {
  return (
    <Modal
      ariaHideApp={false}
      id="errorModal"
      isOpen={open}
      onRequestClose={() => closeErrorPopUp()}
    >
      <div>
        {service === ENTERPRISE_SEARCH_LOCATIONS && (
          <>
            <div className="pop-up-title">
              <FormattedMessage {...messages.enterpriseTitle} />
            </div>
            <div className="pop-up-text margin-text-bottom">
              <FormattedMessage {...messages.enterpriseText} />
            </div>
          </>
        )}
        {service === AUDATARGET_SEARCH_VENDOR && (
          <>
            <div className="pop-up-title">
              <FormattedMessage {...messages.audatargetTitle} />
            </div>
            <div className="pop-up-text margin-text-bottom">
              <FormattedMessage {...messages.audatargetText} />
            </div>
          </>
        )}
        <br />
        <div className="several-buttons-wrapper">
          <Button primary className="pop-up-btn large-button" onClick={() => closeErrorPopUp()}>
            <FormattedMessage {...messages.okay} />
          </Button>
          <br />
          <Button className="black-underline-button" onClick={() => closeErrorPopUp()}>
            <FormattedMessage {...messages.cancel} />
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ErrorPopUpServices;
